<template>
  <div
    class="fullscreen-text-block"
    :class="{ '--alternate-accent': data.backgroundColor.hex === '#FF6D03' }"
    :style="{
      '--background-color': data.backgroundColor.hex,
      '--text-color': data.textColor.hex,
    }"
  >
    <div class="fullscreen-text-block__content row-140-16">
      <div
        v-if="data.title"
        class="fullscreen-text-block__title text-caption m-bottom-8px"
        v-html="data.title"
      />
      <div
        v-if="data.description"
        class="fullscreen-text-block__description text-l-2"
        v-html="data.description"
        v-anim-reveal-text
        data-animate="reveal-text"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PagesCommonFullscreenTextBlock',
}
</script>

<script setup>
const props = defineProps({
  data: Object,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
